import { useScaffold } from "@Light/scaffold";
import clsx from "clsx";

export type StatusChipProps = {
  children: React.ReactNode;
};

export const StatusChip: React.FC<StatusChipProps> = ({ children }) => {
  const scaffold = useScaffold();
  return (
    <div
      className={clsx(
        scaffold.page.colors.text.secondary,
        "border rounded-md px-2 border-gray-300",
        "font-medium text-xs",
      )}
    >
      {children}
    </div>
  );
};
